import React from "react";
import { TextField, FormHelperText, makeStyles} from "@material-ui/core";
import { getIn } from "formik";
import VideocamIcon from '@material-ui/icons/Videocam';
import AudiotrackIcon from '@material-ui/icons/Audiotrack';
import editicon from "../assets/images/edit.png";

export default function({field,form,name,helperText,error,onChange,onBlur,audio,duration,edit,onClick,displayErrorMessage = true,...otherProps}) {
const useStyles = makeStyles(() => ({
video:{fontSize: "120px",color:"#fafafa"},
divclass:{ position: "relative",width: "205px",height: "125px",backgroundColor:"#bdbdbd",fontSize: "1.5em",textAlign: "center",lineHeight: "34px" },
editPen: {
		cursor: "pointer",
		width: 35,position: "absolute",top: 10,right:10
	}
}));
let two=2;
const filesize=26214400;
 const classes = useStyles();
  const changeHandler = event => {
  let file = event.target.files[0];
if(file){
  let reader = new FileReader();
    let base64;
    reader.readAsDataURL(file);
   const SUPPORTED = ["audio/mpeg","audio/*","audio/MP4","audio/MP3"];
    const SUPPORTED_FORMATS1 =["video/*","video/mpeg","video/mp4"];
   if(audio==="video"){
    if(file.size<filesize &&SUPPORTED_FORMATS1.includes(file.type)){
      reader.onloadend = () => {
      form.setFieldValue(field.name,[file=event.target.files[0],base64=reader.result]);
    };
    }
}else{
    if(file.size<filesize &&SUPPORTED.includes(file.type)){
  reader.onloadend = () => {
      form.setFieldValue(field.name,[file=event.target.files[0],base64=reader.result]);
      };
    }
}
}
    if (onChange) {
      onChange(event);
    }
  };
const handleFocusBack=()=>{
setTimeout(function(){
form.setFieldTouched(field.name);
window.removeEventListener('focus', handleFocusBack);
}, 800);
};
const getvideo=()=>{
if(field.value.length>0){
if(edit&&field.value.length>two)
{
return <><video width="205" height="125" src={field.value} controls></video>
<img className={classes.editPen} src={editicon} /></>
}
else{
return <><video width="205" height="125" src={field.value[1]} controls></video>
<img className={classes.editPen} src={editicon} /></>
}
}
else{
return <><VideocamIcon className={classes.video} /><img className={classes.editPen} src={editicon} /></>
}
}
const getaudio=()=>{
if(field.value.length>0){
if(edit&&field.value.length>two){
return <><audio   src={field.value} style={{width:"200px",marginTop:"60px"}}controls></audio >
<img className={classes.editPen} src={editicon} /></>}
else{
return <><audio   src={field.value[1]}  style={{width:"200px",marginTop:"60px"}} controls></audio >
<img className={classes.editPen} src={editicon} /></>
}}
else{
return <><AudiotrackIcon className={classes.video} /><img className={classes.editPen} src={editicon} /></>
}
}
const clickedFileInput=()=>{
    window.addEventListener('focus',handleFocusBack);
};
  const touch = getIn(form.touched, field.name);
  const errorText = getIn(form.errors, field.name);
  return (
  <div style={{display:"flex"}}>
  <div className={classes.divclass}>
  {(audio==="video")?getvideo():""}
  {(audio!=="video")?getaudio():""}

      <TextField
         name={field.name}
         style={{position: "absolute",top: 0,left: 0,opacity: 0,width: "205px",height: "75px"}}
        onChange={changeHandler}
        onClick={clickedFileInput}
        {...otherProps}
        error={touch && errorText ? true : false}
      />
      {displayErrorMessage ? (
        <FormHelperText error={Boolean(touch && errorText)}>
          {(touch && errorText) || helperText}
        </FormHelperText>
      ) : (
        helperText && <FormHelperText>{helperText}</FormHelperText>
      )}
</div>
    </div>
  );
}